<template>
	<div class="dashboard-onboarding-container" :class="{ completed: isCompleted }" @click="stepClick">
		<div class="dashboard-onboarding d-flex">
			<div class="step-icon-container">
				<div class="step-icon" :class="{ completed: isCompleted }">
					<InlineSvg v-if="isCompleted" :src="checkIconUrl" class="step-icon-svg" />
				</div>
			</div>
			<div class="action-heading d-flex">
				<div class="">{{ step_data.heading }}</div>
			</div>
			<div class="chevron-container">
				<InlineSvg :src="chevronIconUrl" class="chevron-icon" />
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ChecklistStep',
		props: {
			step_data: { type: Object },
			isCompleted: { type: Boolean, default: false },
		},
		data() {
			return {
				checkIconUrl: '/images/icons-2025/check.svg',
				chevronIconUrl: '/images/icons/ic-chevron-right.svg',
			}
		},
		methods: {
			stepClick() {
				this.$emit('step-clicked')
			},
		},
	}
</script>

<style lang="scss" scoped>
	.dashboard-onboarding-container {
		padding-top: 2px;
		margin-left: unset;
		max-width: 1000px;
		&:hover {
			cursor: pointer;
		}
	}

	.dashboard-onboarding {
		flex-direction: row;
		align-items: center;
		background-color: var(--stan-white);
		color: var(--stan-primary-dark-color);
		border-radius: 12px;
		margin: 0px 0px;
		gap: 12px;

		.step-icon-container {
			position: relative;
			flex-shrink: 0;
		}

		.step-icon {
			width: 22px;
			height: 22px;
			border-radius: 50%;
			display: flex;
			align-items: center;
			justify-content: center;
			background: #ffffff;
			border: 1.5px solid #a1a9ff;
			position: relative;
			transition: all 0.2s ease;

			&.completed {
				background: #a1a9ff;
				border-color: #a1a9ff;
			}

			.step-icon-svg {
				width: 20px;
				height: 20px;
			}

			::v-deep svg path {
				fill: #131f60;
			}

			&.completed ::v-deep svg path {
				fill: #131f60;
			}
		}

		.action-heading {
			font-family: 'Plus Jakarta Sans';
			font-size: 14px;
			font-style: normal;
			font-weight: 500;
			line-height: 140%;
			flex: 1;
		}

		.chevron-container {
			flex-shrink: 0;
			display: flex;
			align-items: center;
		}

		.chevron-icon {
			width: 24px;
			height: 24px;
			opacity: 0.6;
		}
	}
</style>
